import { DataServer } from "../../../../config.axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

interface IncompleteInspectionDataState {
  IncompleteInspectionData: {
    load: boolean;
    data: [];
  };
}

export const inspectionSlice = createSlice({
  name: "IncompleteInspectionData",
  initialState: {
    IncompleteInspectionData: {
      load: false,
      data: [],
    },
  } as IncompleteInspectionDataState,
  reducers: {},
  extraReducers: (builder: any) => {
    builder
      .addCase(fetchIncompleteInspectionData.pending, (state: IncompleteInspectionDataState) => {
        state.IncompleteInspectionData.load = true;
      })
      .addCase(fetchIncompleteInspectionData.fulfilled, (state: IncompleteInspectionDataState, action: any) => {
        state.IncompleteInspectionData.data = action.payload;
        state.IncompleteInspectionData.load = false;
      })
      .addCase(fetchIncompleteInspectionData.rejected, (state: IncompleteInspectionDataState) => {
        state.IncompleteInspectionData.load = false;
      });
  },
});

export default inspectionSlice.reducer;

export const fetchIncompleteInspectionData = createAsyncThunk(
  "IncompleteInspectionData/fetchIncompleteInspectionData",
  async (param: {apiParam : {warehouse_id: any, cycle: any}}, thunkAPI) => {

    try {
      const { data } = await DataServer.post("api/getIncompleteInspectionData" , {
        warehouse_id: param.apiParam.warehouse_id,
        cycle: param.apiParam.cycle,
      });
      return data.data;
    } catch (error) {
    }
  }
);
